import React, { useEffect, useState, useRef } from "react";
import NotificationPagination from "../../../components/CustomPagination";
import BidNotification from "./NotificationTypes/BidNotification";
import NotFoundText from "@/components/NotFoundText";
import { NotificationContext } from "./NotificationContext";
import "react-loading-skeleton/dist/skeleton.css";

const UserNotifications: React.FC<any> = ({ notifications, isLoading }) => {
  const { paginationArgs, setPaginationArgs } =
    React.useContext(NotificationContext);

  const [newNotificationIds, setNewNotificationIds] = useState<Set<string>>(
    new Set()
  );
  const isInitialized = useRef(false);
  const previousNotificationIds = useRef<Set<string>>(new Set());
  const initializationTimer = useRef<NodeJS.Timeout | null>(null);

  const total = paginationArgs?.total || 0;
  const hasItems = notifications && notifications?.length > 0;

  useEffect(() => {
    if (notifications && Array.isArray(notifications) && !isLoading) {
      const currentIds = new Set(notifications.map((n: any) => n.id));

      if (!isInitialized.current) {
        // Clear any existing timer
        if (initializationTimer.current) {
          clearTimeout(initializationTimer.current);
        }

        // Wait 1 second after SWR finishes loading to ensure all initial data is settled
        initializationTimer.current = setTimeout(() => {
          previousNotificationIds.current = currentIds;
          isInitialized.current = true;
        }, 1000);

        return;
      }

      const newIds = new Set<string>();
      currentIds.forEach((id) => {
        if (!previousNotificationIds.current.has(id)) {
          newIds.add(id);
        }
      });

      if (newIds.size > 0) {
        setNewNotificationIds(newIds);

        const timer = setTimeout(() => {
          setNewNotificationIds(new Set());
        }, 5000);

        return () => clearTimeout(timer);
      }

      previousNotificationIds.current = currentIds;
    }
  }, [notifications, isLoading]);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (initializationTimer.current) {
        clearTimeout(initializationTimer.current);
      }
    };
  }, []);

  return (
    <div className="flex flex-col space-y-4">
      {(total <= 0 || !notifications?.length) && !notifications?.length && (
        <>
          <NotFoundText
            title="Inga notiser"
            description="Inga notiser hittades med de valda filtren."
          />
        </>
      )}
      {!!hasItems &&
        notifications &&
        notifications?.map((notification: any, index: number) => (
          <BidNotification
            key={notification.id || index}
            notification={notification}
            isNew={newNotificationIds.has(notification.id)}
          />
        ))}
      {!!hasItems && (
        <NotificationPagination
          paginationArgs={paginationArgs}
          setPaginationArgs={setPaginationArgs}
        />
      )}
    </div>
  );
};

export default React.memo(UserNotifications);
